<div class="row">
  <div class="navbar navbar-default">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-6">
          <ul class="nav navbar-nav">
            <li routerLinkActive="active">
              <a routerLink="books">Books</a>
            </li>
          </ul>
        </div>
        <div class="col-xs-6">
          <ul class="nav navbar-nav navbar-right">
            <li routerLinkActive="active" *ngIf="!isAuth">
              <a routerLink="auth/signup">Create an account</a>
            </li>
            <li routerLinkActive="active" *ngIf="!isAuth">
              <a routerLink="auth/signin">Sign In</a>
            </li>
            <li>
              <a (click)="onSignOut()" *ngIf="isAuth" style="cursor: pointer;">Log Out</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>